<!--評分完成頁面-->
<template>
    <div class="feedback-confirmation-container">
        <img class="logo" alt="Vurbo.ai" src="@shared-assets/images/logos/Vurbo.ai Logo 2.svg" />
        <!--感謝您的參與，-->
        <h2 class="thanks-message">
            {{ t('Components.MeetingEnd.FeedbackConfirmation.ThanksMessage') }}
        </h2>
        <!--希望翻譯為您帶來更好的活動體驗。-->
        <p class="working-message">
            {{ t('Components.MeetingEnd.FeedbackConfirmation.WorkingMessage') }}
        </p>
        <!--探索更多功能按鈕-->
        <button class="explore-button" type="button" @click="exploreMore">
            {{ t('Components.MeetingEnd.FeedbackConfirmation.ExploreMoreFeatures') }}
        </button>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
    name: 'FeedbackConfirmation',
    setup() {
        // i18n
        const { t } = useI18n()

        /**
         * 跳轉至更多功能頁面
         * @return {void}
         */
        const exploreMore = (): void => {
            window.open('https://vurbo.ai/', '_blank')
        }

        return {
            t,
            exploreMore,
        }
    },
})
</script>
<style lang="scss" scoped>
@use '@shared-assets/scss/variables' as *;

.feedback-confirmation-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 500px;
    padding: 0 16px;

    .logo {
        width: 200px;
        margin-bottom: 30px;
    }

    .thanks-message {
        color: var(--ui-grey-darkest);
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 8px;
    }

    .working-message {
        color: var(--ui-grey-darkest);
        font-size: 18px;
        margin: 0;
    }

    .explore-button {
        margin-top: 24px;
        border-radius: 24px;
        background: var(--ui-ignite);
        color: #fff;
        font-weight: 500;
        font-size: 16px;
        height: 48px;
        padding: 0 32px;
        border: none;
        cursor: pointer;
    }
}

@media (max-width: #{$breakpoint-sm - 1}) {
    .feedback-confirmation-container {
        .logo {
            width: 150px;
        }

        .thanks-message {
            font-size: 20px;
        }

        .working-message {
            font-size: 16px;
        }

        .explore-button {
            font-size: 14px;
            height: 44px;
        }
    }
}
</style>
